export default __webpack_public_path__ + "images/logo-nvent.svg?30dd05d79da9be324f2143b075186d54";